import { FC } from "react";
import ManagementPlan from "./ManagementPlan";
import TreatmentPlan from "./TreatmentPlan";
import ClinicalImpression from "./ClinicalImpression";
import PatientManagementPlanProvider from "./PatientManagementPlanProvider";
export const wordBreak = "#$,"
const PatientManagementPlan: FC = () => {
  return (
    <PatientManagementPlanProvider>
      <div className="flex flex-col gap-y-2">
        <ManagementPlan />
        <TreatmentPlan />
        <ClinicalImpression />
      </div>
    </PatientManagementPlanProvider>
  );
};

export default PatientManagementPlan;
